import { Stencil } from "leatherman-js/models";
import store from "@/store";

const handlers = (event, data) => {
  switch (event) {
    case "virt-guest-cloudaccount-stencil:add":
      let newStencil = Stencil.formatLegacy(data);
      if (newStencil.site.id === store.getters["sites/getItem"]?.id) {
        store.dispatch("stencils/refreshList", { siteId: newStencil.site.id });
      }
      store.dispatch("allStencils/refreshList");
      break;
    case "virt-guest-cloudaccount-stencil:update":
      let updatedStencil = Stencil.formatLegacy(data);
      if (updatedStencil.site.id === store.getters["sites/getItem"]?.id) {
        store.dispatch("stencils/refreshList", { siteId: updatedStencil.site.id });
      }
      store.dispatch("allStencils/refreshList");
      break;
    case "virt-guest-cloudaccount-stencil:delete":
      store.dispatch("stencils/refreshList");
      store.dispatch("allStencils/refreshList");
      break;
  }
};

export default handlers;
